"use client";

import "@/styles/progressBar.css";
// import { useUser } from "./username-context";
import { Rank, UserInformation } from "@/lib/declarations";
// import { useMemo } from "react";
import _ from "lodash";
import { GetSealRank } from "@/lib/helper";
import { cn } from "@heroui/react";
// import { useAtomValue } from "jotai";
import useUserDetails from "./hooks/data/use-user-details";
import { useMemo } from "react";

export default function UserProfileCard({ className }: { className?: string }) {
  const hash = useMemo(() => _.sampleSize("WXYZ0123456789".split("").join(""), 4), []);
  const [data] = useUserDetails();

  if (!data) return;
  const { username, rank } = data.user_information;
  // const userInfo = useAtomValue()
  const { min_exp, max_exp, current_exp, label } = (rank as Rank) || {
    min_exp: 0,
    max_exp: 1000,
    current_exp: 0,
  };

  // const { username, rank } = useMemo(() => data?.user_information || {}, [data]);
  // const { min_exp, max_exp, current_exp, label } = useMemo(
  //   () =>
  //     (rank as Rank) || {
  //       min_exp: 0,
  //       max_exp: 1000,
  //       current_exp: 0,
  //     },
  //   [rank]
  // );

  const GetProgress = (current: number, min: number, max: number) => {
    const result = Math.min(100, Math.max(0, (current / max) * 100)) / 100;
    return result;
  };

  const sealRank = GetSealRank(current_exp || 0);
  const memberGradient = ["#5AA386", "#17704E", "#0D836D", "#27DDB3", "#000000"];
  const bronzeGradient = ["#FFEDE5", "#EFB4A2", "#905546", "#5D362A", "#4D291D"];
  const silverGradient = ["#FFFFFF", "#B6B8BB", "#E6EBFD", "#606062", "#BFC1C3"];
  const goldGradient = ["#FBF88A", "#DBC765", "#AC7A2D", "#C39F4D", "#B48835"];
  const platinumGradient = ["#FDAFA0", "#F86B64", "#B01A21", "#DD2C27", "#F5665A"];
  const diamondGradient = ["#16E3FF", "#4BC1FF", "#0256C6", "#174786", "#15E0FE"];
  const masterGradient = ["#FBF88A", "#DBC765", "#AC7A2D", "#C39F4D", "#B48835"];

  const RankGradients = [
    bronzeGradient,
    silverGradient,
    goldGradient,
    platinumGradient,
    diamondGradient,
    masterGradient,
  ];

  enum RankColor {
    bronze = 0,
    silver = 1,
    gold = 2,
    platinum = 3,
    diamond = 4,
    master = 5,
  }
  return (
    <>
      <svg
        viewBox="0 0 800 490"
        className={cn("transform-[translateZ(1px)] size-full transform-gpu will-change-[filter]", className)}
      >
        <defs>
          <filter
            id={"ds-" + hash}
            x="-50%"
            y="-50%"
            width={800 / 10}
            height={490 / 10}
            // filterUnits="objectBoundingBox"
            // primitiveUnits="objectBoundingBox"
            filterRes="500 500"
          >
            <feDropShadow dx="-6" dy="6" stdDeviation="5" floodColor="black" floodOpacity="0.5" />
          </filter>
          {sealRank.rankBackground == "member" ? (
            <linearGradient id={"rank-gradient-" + hash} x1="0%" y1="0%" x2="100%" y2="0%">
              {memberGradient.map((color, index) => {
                return <stop key={index} offset={String(index * 100 - 50) + "%"} style={{ stopColor: color }} />;
              })}
            </linearGradient>
          ) : (
            <linearGradient id={"rank-gradient-" + hash} x1="0%" y1="0%" x2="100%" y2="0%">
              {RankGradients[RankColor[sealRank.rankBackground as keyof typeof RankColor]].map((color, index) => {
                return <stop key={index} offset={String(index * 100 - 50) + "%"} style={{ stopColor: color }} />;
              })}
            </linearGradient>
          )}
        </defs>
        {/* card background */}
        <image href={`/vip/bg/${sealRank.rankBackground}.png`} height={"100%"} width={"100%"} />
        {/* seal */}
        <image
          x={"70%"}
          y={"5%"}
          href={`/vip/rank/${sealRank.rankBackground}.png`}
          width={"25%"}
          filter={`url(#ds-${hash})`}
        />
        {!_.isNaN(sealRank.rankIndex) && (
          <>
            {/* stars */}
            <image
              x={"70%"}
              y={"49.5%"}
              href={`/vip/rank/rank${4 - sealRank.rankIndex}.png`}
              width={"25%"}
              filter={`url(#ds-${hash})`}
            />
          </>
        )}
        <text
          x="48"
          y="10%"
          fill="white"
          dominantBaseline="hanging"
          textAnchor="start"
          fontSize={40}
          fontWeight={600}
          filter={`url(#ds-${hash})`}
        >
          Hi, {username}
        </text>
        <text
          x="48"
          y="25%"
          fill={`url(#rank-gradient-${hash})`}
          // stroke="black"
          // strokeOpacity={0.25}
          // strokeWidth={4}
          dominantBaseline="hanging"
          textAnchor="start"
          fontSize={72}
          fontWeight={600}
          filter={`url(#ds-${hash})`}
          fontFamily="Conthrax"
        >
          {label?.toUpperCase() || "MEMBER"}
        </text>
        <text
          x="48"
          y="74%"
          fill="white"
          dominantBaseline="auto"
          textAnchor="start"
          fontSize={64}
          fontWeight={600}
          filter={`url(#ds-${hash})`}
        >
          XP
        </text>
        <rect id="bg" y={"77.5%"} x={"5%"} width={"90%"} height={14} rx={10} fill="white" filter={`url(#ds-${hash})`} />
        <rect
          y={"77.5%"}
          x={"5%"}
          // multiply by 90%, because the width is 90% of the total width
          width={String(GetProgress(current_exp, min_exp, max_exp) * 90) + "%"}
          height={16}
          rx={10}
          fill="#258966"
        />
        <text
          x="95%"
          y="74%"
          fill="white"
          textAnchor="end"
          fontSize={28}
          fontWeight={200}
          filter={`url(#ds-${hash})`}
          dominantBaseline="auto"
        >
          {current_exp?.toLocaleString() || 0} /{" "}
          <tspan fill="white" fontWeight={600}>
            {/* {sealRank.nextRankEXP.toLocaleString()} */}
            {max_exp?.toLocaleString() || 1000}
          </tspan>{" "}
          &gt; <tspan fontWeight={600}>{sealRank.nextRankName.toUpperCase()}</tspan>
        </text>
        <foreignObject x={40} y={"85%"} width={800} height={490} filter={`url(#ds-${hash})`}>
          <div className="flex items-center justify-start gap-2 text-[2.5em] font-semibold leading-none text-white min-[450px]:text-xl">
            <span className="icon-icon38" /> 0 LP <span className="icon-icon7" />
          </div>
        </foreignObject>
      </svg>
    </>
  );
}

// const old = () => {
//   <div
//     className="relative aspect-[800/490] rounded-lg bg-cover bg-center p-4 shadow-lg min-[450px]:p-6"
//     style={{
//       backgroundImage: `url(/vip/bg/${GetSealRank(current_exp)?.rankBackground}.png)`,
//     }}
//   >
//     <div className="flex items-center gap-2">
//       <h2 className="text-lg font-semibold min-[450px]:text-2xl">Hi, {username}</h2>
//       {/* <div className="aspect-[400/98] bg-[url(/vip/status/frame-verified.png)] bg-cover bg-center px-4 text-tiny">
//           Verified
//         </div> */}
//       {/* <span className="rounded bg-yellow-600 px-2 py-1 text-xs">Pending</span> */}
//     </div>
//     <h1 className="mt-2 inline-block bg-gradient-to-r from-yellow-100 to-yellow-500 bg-clip-text text-3xl font-bold text-opacity-0">
//       {GetSealRank(current_exp || 0)?.rankName}
//     </h1>
//     <div className="absolute bottom-0 left-0 w-full space-y-2 px-4 pb-4 min-[450px]:px-6 min-[450px]:pb-8">
//       <div className="flex items-end justify-between text-tiny">
//         <div className="block text-2xl font-bold leading-none min-[450px]:text-4xl">XP</div>
//         <div className="text-tiny leading-none min-[450px]:text-lg">
//           {Number(current_exp || 0).toLocaleString()} /{" "}
//           <span className="font-bold">{GetSealRank(current_exp || 0)?.nextRankEXP.toLocaleString()}</span> &gt;{" "}
//           {GetSealRank(current_exp || 0)?.nextRankName}
//         </div>
//       </div>
//       <div className="relative h-1.5 w-full rounded-full bg-white">
//         <div
//           className="h-full rounded-full bg-primary"
//           style={{ width: String(GetProgress(current_exp || 0, min_exp || 0, max_exp || 1000)) + "%" }}
//         ></div>
//       </div>
//       <div className="flex items-center justify-start gap-2 text-medium font-semibold leading-none min-[450px]:text-xl">
//         <span className="icon-icon38" /> 0 LP <span className="icon-icon7" />
//       </div>
//     </div>
//     <RankSeal rank={Number(GetSealRank(current_exp || 0)?.rankIndex)} className="!absolute right-0 top-0 m-6 w-20" />
//   </div>;
// };
